import React, { useEffect, useState } from "react";
import "./index.less";
import loading_icon from "@/assets/templateImgs/loading_icon.png";

export default function StartLoading() {
  return (
    <div className="loading">
      <div className="img_icon">
        <img src={loading_icon} alt="" width="100" height="100" />
      </div>
      <div className="dot">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
